export const MAX_STRING_FILTER_COMBINATIONS = 4

export const PLAN_TIERS = {
  FREE: "Free",
  BUILD: "Build",
  SCALE: "Scale",
}

// Maps legacy Stripe product_name values to canonical tiers
const PLAN_NAME_TO_TIER = {
  Developer: PLAN_TIERS.BUILD,
  Build: PLAN_TIERS.BUILD,
  Professional: PLAN_TIERS.SCALE,
  Scale: PLAN_TIERS.SCALE,
}

// null = no cap enforced in the UI
export const PLAN_LIMITS = {
  [PLAN_TIERS.FREE]: {
    maxDatasets: 0,
    maxSchemasPerDataset: 0,
    maxRecordsPerSchema: 0,
    maxFieldsPerSchema: 0,
  },
  [PLAN_TIERS.BUILD]: {
    maxDatasets: 2,
    maxSchemasPerDataset: 3,
    maxRecordsPerSchema: 50000,
    maxFieldsPerSchema: 14,
  },
  [PLAN_TIERS.SCALE]: {
    maxDatasets: null,
    maxSchemasPerDataset: null,
    maxRecordsPerSchema: null,
    maxFieldsPerSchema: null,
  },
}

export const CONTACT_SALES_URL = "https://blindinsight.com/contact"

/**
 * Returns the canonical plan tier for an organization.
 * Any active paid subscription with an unrecognized plan name defaults to Build.
 */
export function getPlanTier(org) {
  const stripe = org?.settings?.stripe
  if (!stripe?.active) return PLAN_TIERS.FREE
  return PLAN_NAME_TO_TIER[stripe.product_name] ?? PLAN_TIERS.BUILD
}

/** Returns the limit object for the org's current plan. */
export function getPlanLimits(org) {
  return PLAN_LIMITS[getPlanTier(org)]
}

/**
 * Returns true if the org is on a plan with unlimited access (Scale).
 * Preserved for backward compatibility.
 */
export function isProAccount(org) {
  return getPlanTier(org) === PLAN_TIERS.SCALE
}
